import { Primary } from "../buttons/Primary";

export function GlobalErrorFallback() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-red/10 px-4">
            <div className="max-w-md text-center shadow-lg rounded-md bg-white p-8">
                <h1 className="text-xl font-semibold mb-2">Algo salió mal.</h1>
                <p className="text-gray-600 mb-6">
                    Ocurrió un error inesperado. Por favor intenta de nuevo o contáctanos por
                    WhatsApp si el problema persiste.
                </p>
                <a href="/" className="w-56 mx-auto block">
                    <Primary text="Volver al inicio" />
                </a>
            </div>
        </div>
    );
}
